import Cookies from 'js-cookie'
import {Message} from 'element-ui'
import util from '@/util'
import api from '@/api'
import filter from '@/common/filter'
import store from '@/store'
import config from '$config'
import {
    generalFieldList,
    timelineFieldList,
    helperFieldList,
    employerFieldList,
    jobOfferFieldList,
    feeBreakdownFieldList,
    otherFieldList,
} from '@/common/contractTemplateConfig'
import i18n from '@/lang'
import {formatDate, getTimezoneLabel} from '@/util/date-format'
import { saveWin } from './downloadOssWinManage'
import validate from '@/common/validate'

const ACCESS_TOKEN = 'peanutManageAccessToken'
const REFRESH_TOKEN = 'peanutMangeRefreshToken'

export default {
    getHelperTypeMap(allHelperTypeMap, countryAreaId?) {
        let helperTypeMap: any[] = [...allHelperTypeMap]
        switch (countryAreaId) {
            case 1192: // 新加坡
                helperTypeMap = helperTypeMap.filter((item, index) => [0, 3, 1, 2].includes(item.value))
                break
            case 1098: // 香港
                helperTypeMap = helperTypeMap.filter((item, index) => [0, 3, 4, 2].includes(item.value))
                break
            case 1210: // 台湾
                helperTypeMap = helperTypeMap.filter((item, index) => [0, 3, 5, 2].includes(item.value))
                break
            case 1045: // 中国大陆
                helperTypeMap = helperTypeMap.filter((item, index) => [0, 3, 6, 2].includes(item.value))
                break
            case 1129: // 马来西亚
                helperTypeMap = helperTypeMap.filter((item, index) => [0, 3, 7, 2].includes(item.value))
                break
            case 1163: // 阿曼
                helperTypeMap = helperTypeMap.filter((item, index) => [0, 3, 8, 2].includes(item.value))
                break
            case 1176: // 卡塔尔
                helperTypeMap = helperTypeMap.filter((item, index) => [0, 3, 9, 2].includes(item.value))
                break
            case 1225: // 阿拉伯联合酋长国 United Arab Emirates
                helperTypeMap = helperTypeMap.filter((item, index) => [0, 3, 10, 2].includes(item.value))
                break
            case 1187: // 沙特 Saudi Arabia
                helperTypeMap = helperTypeMap.filter((item, index) => [0, 3, 11, 2].includes(item.value))
                break
            case 1126: // 澳门 Macao
                helperTypeMap = helperTypeMap.filter((item, index) => [0, 3, 12, 2].includes(item.value))
                break
            default:
                break
        }
        if (countryAreaId !== 1045) {
            helperTypeMap = helperTypeMap.filter(item => item.value !== 6)
        }
        return helperTypeMap
    },
    copyTextWithConfirm(vm, text: string, tips?: string) {
        vm.$confirm('', 'Confirm copy?', {
            confirmButtonText: vm.$t1('confirm'),
            cancelButtonText: vm.$t1('cancel'),
        }).then(() => {
            this.copyText(text, tips)
        })
    },
    copyBrTextWithConfirm(vm, text: string, tips?: string, confirmtips = 'Confirm copy?') {
        vm.$confirm('', confirmtips, {
            confirmButtonText: vm.$t1('confirm'),
            cancelButtonText: vm.$t1('cancel'),
        }).then(() => {
            this.copyBrText(text, tips)
        })
    },
    copyText(text: string, tips?: string) {
        let copyInput
        if (!document.getElementsByClassName('copyInputComponent').length) {
            let div = document.createElement('div')
            div.innerHTML = '<input class="copyInputComponent" readonly unselectable="on" style="width: 1px; height: 1px; border: 0px; padding: 0px;">'
            document.body.appendChild(div)
        }
        copyInput = document.getElementsByClassName('copyInputComponent')[0]
        copyInput.value = text
        copyInput.select()
        document.execCommand('Copy')
        Message.success(tips || i18n.t('copy_successfully') as string)
    },
    copyBrText(text: string, tips?: any) {
        const textarea = document.createElement('textarea') // 直接构建textarea  「注意：这里为了实现换行，需要创建textarea，如果用input的话，实现不了换行。」
        textarea.value = text // 设置内容    「注意： \r\n 是 换行 符号
        document.body.appendChild(textarea) // 添加临时实例
        textarea.select() // 选择实例内容
        document.execCommand('Copy') // 执行复制
        document.body.removeChild(textarea) // 删除临时实例
        if (!tips) {
            Message.success(i18n.t('copy_successfully') as string)
        } else {
            Message.success(tips)
        }
    },
    /**
     * 开发环境本地cookie设置
     */
    setToken(data: any): void {
        if (process.env.NODE_ENV === 'development') {
            Cookies.set(REFRESH_TOKEN, data.refreshToken)
            Cookies.set(ACCESS_TOKEN, data.token)
        }
    },
    getToken(): '' | undefined | string {
        return process.env.NODE_ENV === 'development' ? Cookies.get(ACCESS_TOKEN) && Cookies.get(REFRESH_TOKEN) : ''
    },
    removeToken(): void {
        if (process.env.NODE_ENV === 'development') {
            Cookies.remove(ACCESS_TOKEN)
            Cookies.remove(REFRESH_TOKEN)
        }
    },
    /**
     * 获取相对路径
     * @param url  {String} url
     * @returns     {String} 相对路径
     */
    getRelativeUrl(url: string): string {
        return url.replace(/^http[s]*:\/\/.+?\//, '')
    },
    /**
     * 获取完整路径
     * @param url  {String} url
     * @returns     {String} 相对路径
     */
    getCompleteUrl(url: string): string {
        if (!url || url.startsWith('http')) {
            return url
        }
        return config.ossPrefix + url
    },
    openOssUrl(url) {
        if (!url) return
        window.open(this.getCompleteUrl(url))
    },
    /**
     * 针对el-date-picker组件，返回有固定最大值限制的pickerOptions
     * @param limit  {Number}  最大值时间戳
     * @returns     {Object} pickerOptions
     */
    getBeforePickerOptions(limit: number): Object {
        return {
            disabledDate(time: any) {
                return time.getTime() > limit
            },
        }
    },
    /**
     * 针对el-date-picker组件，返回有固定最小值限制的pickerOptions
     * @param limit  {Number}  最大值时间戳
     * @returns     {Object} pickerOptions
     */
    getAfterPickerOptions(limit: number): Object {
        return {
            disabledDate(time: any) {
                return time.getTime() < limit
            },
        }
    },
    /**
     * 针对el-date-picker组件，返回有最大值限制的pickerOptions
     * @param obj   {Object} 最大值所在对象
     * @param path  {String} 最大值在对象中的路径，例如'a.b.c'
     * @returns     {Object} pickerOptions
     */
    getLargestPickerOptions(obj: Object, path: string): Object {
        return {
            disabledDate(time: any) {
                let largestTime: any = util.getValueByPath(obj, path)
                if (largestTime) {
                    return time.getTime() > new Date(largestTime).getTime()
                }
            },
        }
    },
    /**
     * 针对el-date-picker组件，返回有最小值限制的pickerOptions
     * @param obj   {Object} 最小值所在对象
     * @param path  {String} 最小值在对象中的路径，例如'a.b.c'
     * @returns     {Object} pickerOptions
     */
    getMinimalPickerOptions(obj: Object, path: string): Object {
        return {
            disabledDate(time: any) {
                let minimalTime: any = util.getValueByPath(obj, path)
                if (minimalTime) {
                    return time.getTime() < new Date(minimalTime).getTime()
                }
            },
        }
    },

    /**
     * 从阿里云下载文件
     * @param url   {string} 文件的路径
     * @param name   {string} 下载的文件名
     */
    downloadOssFile(url: string, name: string) {
        if (!url) return
        if (!name) {
            name = url.substring(url.lastIndexOf('/') + 1)
        }
        const t = Date.now() + ''
        const childWin = window.open(config.ossPrefix + 'web-static/assets/downloadOSS.html?url=' + encodeURIComponent(url) + '&name=' + encodeURIComponent(name) + '&t=' + t)
        saveWin(childWin, t)
    },

    /**
     * 获取阿里云文件
     * @param url   {string} 文件的路径
     */
    getOssFile(url: string) {
        return api.download_file({fileName: url}, {
            responseType: 'blob',
        }).then(({data}) => {
            try {   // 如果是json格式，说明接口报错了
                let res = JSON.parse(data)
                return res
            } catch (e) {
                return data
            }
        }).catch(() => {
        })
    },

    /**
     * 将所有skill的数组格式化为各类skill的对象
     * @param caringSkillsDic {Array}   caringSkill字典
     * @param skillList {Array}     所有skill的数组
     * @returns         {Object}    格式化后的四类skill
     */
    formatSkill(caringSkillsDic: any[], skillList: any[], skillExperienceMap: any[]): any {
        let caringSkillModel: any = {}

        let cookingSkillModel: any = {
            skillType: 49,
            skillName: [],
            experience: null,
            level: null,
            observation: null,
            experienceMap: skillExperienceMap,
            disableList: [],
            pointByManager: false,
            willingness: '',
        }

        let languageSkillModel: any = {
            skillType: 65,
            skillName: [],
            experience: null,
            level: null,
            observation: null,
            experienceMap: skillExperienceMap,
            disableList: [],
            pointByManager: false,
            willingness: '',
        }

        let otherSkillModel: any = {
            skillType: 78,
            skillName: [],
            experience: null,
            level: null,
            observation: null,
            experienceMap: skillExperienceMap,
            disableList: [],
            pointByManager: false,
            willingness: '',
        }
        caringSkillsDic.forEach(item => {
            if (!caringSkillModel['caring' + item.value]) {
                caringSkillModel['caring' + item.value] = {
                    type: item.parentName,
                    skillName: item.value,
                    skillType: item.parentId,
                    name: item.name,
                    experience: null,
                    level: null,
                    observation: null,
                    experienceMap: skillExperienceMap,
                    willingness: '',
                    experienceRemainMonth: null,
                }
            }
        })
        if (skillList) {
            skillList.forEach((item: any) => {
                if (item.type === 'caringSkills') {
                    if (item.dealYear) {
                        item.experienceMap = this.formatExperienceMap(skillExperienceMap, item.dealYear)
                    }
                    Object.assign(caringSkillModel['caring' + item.skillName], item)
                }
                if (item.type === 'cookingSkills') {
                    if (!cookingSkillModel.skillName.length) {
                        cookingSkillModel.skillType = item.skillType
                        cookingSkillModel.experience = item.experience
                        cookingSkillModel.level = item.level
                        cookingSkillModel.observation = item.observation
                        cookingSkillModel.pointByManager = item.pointByManager
                        cookingSkillModel.willingness = item.willingness
                        if (item.dealYear) {
                            cookingSkillModel.experienceMap = this.formatExperienceMap(skillExperienceMap, item.dealYear)
                        }
                    }
                    if (item.local === 1) {
                        cookingSkillModel.disableList.push(item.skillName)
                    }
                    if (cookingSkillModel.skillName.indexOf(item.skillName) === -1) {
                        cookingSkillModel.skillName.push(item.skillName)
                    }
                }
                if (item.type === 'languageSkills') {
                    if (!languageSkillModel.skillName.length) {
                        languageSkillModel.skillType = item.skillType
                        languageSkillModel.experience = item.experience
                        languageSkillModel.level = item.level
                        languageSkillModel.observation = item.observation
                        languageSkillModel.pointByManager = item.pointByManager
                        languageSkillModel.willingness = item.willingness
                        if (item.dealYear) {
                            languageSkillModel.experienceMap = this.formatExperienceMap(skillExperienceMap, item.dealYear)
                        }
                    }
                    if (item.local === 1) {
                        languageSkillModel.disableList.push(item.skillName)
                    }
                    if (languageSkillModel.skillName.indexOf(item.skillName) === -1) {
                        languageSkillModel.skillName.push(item.skillName)
                    }
                }
                if (item.type === 'otherSkills') {
                    if (!otherSkillModel.skillName.length) {
                        otherSkillModel.skillType = item.skillType
                        otherSkillModel.experience = item.experience
                        otherSkillModel.level = item.level
                        otherSkillModel.observation = item.observation
                        otherSkillModel.pointByManager = item.pointByManager
                        otherSkillModel.willingness = item.willingness
                        if (item.dealYear) {
                            otherSkillModel.experienceMap = this.formatExperienceMap(skillExperienceMap, item.dealYear)
                        }
                    }
                    if (item.local === 1) {
                        otherSkillModel.disableList.push(item.skillName)
                    }
                    if (otherSkillModel.skillName.indexOf(item.skillName) === -1) {
                        otherSkillModel.skillName.push(item.skillName)
                    }
                }
            })
        }
        return {
            caringSkillModel, cookingSkillModel, languageSkillModel, otherSkillModel,
        }
    },

    formatExperienceMap(skillExperienceMap, val) {
        if (val && !skillExperienceMap.find(v => v.value === val)) {
            return [
                ...[{name: val + ' years', value: val}],
                ...skillExperienceMap,
            ]
        }
        return skillExperienceMap
    },

    replaceEmptyWithSpace(val) {
        return (val == null || val === '') ? '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' : val
    },

    goWhatsApp(mobile?: string) {
        if (mobile) {
            mobile = mobile.replace('+', '')
        }
        window.open('https://wa.me/' + (mobile || '6589426326'))
    },

    contractUpdateConfirm(vm, data) {
        return vm.$confirm(`
            <div>The fields to be changed exist in the following document(s) of which signing link has been created:</div>
            <ul class="mg0"
            style="color: #222;
                list-style: disc;
                margin-left: 14px !important;">`
                + data.fileName.reduce((count, item) => count + '<li>' + item + '</li>', '')
            + `</ul>
            <div class="text-warning1">
                <i class="iconfont iconwarning"></i>
                Document(s) will be automatically updated and you will need to resend new link to signees for them to sign.
            </div>
            `, 'Confirm to save changes?', {
            confirmButtonText: vm.$t('confirm'),
            cancelButtonText: vm.$t('cancel'),
            dangerouslyUseHTMLString: true,
        })
    },
    contractCollectUpdateConfirm(vm, data) {
        return vm.$confirm('', `
            Cannot be modified, because documents
                ${data.fileName.reduce((count, item) => count + '《' + item + '》', '')}
            signing link has been created.Contact the agency to modify
            `, {
            confirmButtonText: vm.$t('ok'),
            showCancelButton: false,
        })
    },
    insuranceContractUpdateConfirm(vm, data, status) {
        return vm.$confirm(`
            <div>The fields to be changed exist in the following document(s) of which signing link has been created:</div>
            <ul class="mg0">`
                + data.map(n => '<li>' + filter.getValueById(n, (<any> store).state.dataMap.insurancePdfNameMap) + '</li>', '')
            + `</ul>
            <div class="text-warning1">
                <i class="iconfont iconwarning"></i>
                ${[4, 5, 8].includes(status)
        ? `The document will be automatically updated and you will need to notify the business person to cancel the currentinsurance
        and resend the new link to signees for them to sign.`
        : 'Document(s) will be automatically updated and you will need to resend new link to signees for them to sign.'}
            </div>
            `, 'Confirm to save changes?', {
            confirmButtonText: vm.$t('confirm'),
            cancelButtonText: vm.$t('cancel'),
            dangerouslyUseHTMLString: true,
        })
    },
    autoContractUpdate(vm) {
        return vm.$confirm('', 'Updates from supplier will not be synchronized auto, you can synchronize updates manually in to-do list. ', {
            confirmButtonText: vm.$t('confirm'),
            cancelButtonText: vm.$t('cancel'),
        })
    },
    supplierUpdateConfirmSign(vm, data) {
        return vm.$confirm(`
            <div>The fields to be changed exist in the following document(s) of which signing link has been created:</div>
            <ul style="color: #222;
    list-style: disc;
    margin-left: 14px !important;">`
            + data.effectSignFileList.reduce((count, item) => count + '<li>' + (filter.getValueById(item, (<any> store).state.dataMap.contractPdfNameMap) || item) + '</li>', '')
            + `</ul>
            <div class="text-warning1">
                <i class="iconfont iconwarning"></i>
                Document(s) will be automatically updated and you will need to resend new link to signees for them to sign.
            </div>
            `, 'Confirm to save changes?', {
            confirmButtonText: vm.$t('confirm'),
            cancelButtonText: vm.$t('cancel'),
            dangerouslyUseHTMLString: true,
        })
    },
    supplierUpdateConfirm(vm, data) {
        return vm.$confirm(`
            <div>The link of info collection will be automatically updated and you will need to resend new link to agency</div>
            <div class="line" style="margin-bottom: 10px;border: 1px solid #E7E7E7;margin-top: 10px;"></div>
            <div>The fields to be changed exist in the following document(s) of which signing link has been created:</div>
            <ul style="color: #222;
    list-style: disc;
    margin-left: 14px !important;">`
            + data.effectSignFileList.reduce((count, item) => count + '<li>' + (filter.getValueById(item, (<any> store).state.dataMap.contractPdfNameMap) || item) + '</li>', '')
            + `</ul>
            <div class="text-warning1">
                <i class="iconfont iconwarning"></i>
                Document(s) will be automatically updated and you will need to resend new link to signees for them to sign.
            </div>
            `, 'Confirm to save changes?', {
            confirmButtonText: vm.$t('confirm'),
            cancelButtonText: vm.$t('cancel'),
            dangerouslyUseHTMLString: true,
        })
    },
    supplierUpdateConfirmLink(vm) {
        return vm.$confirm(`
            <div>The link of info collection will be automatically updated and you will need to resend new link to agency</div>
            `, 'Confirm to save changes?', {
            confirmButtonText: vm.$t('confirm'),
            cancelButtonText: vm.$t('cancel'),
            dangerouslyUseHTMLString: true,
        })
    },
    convertToRoman(num) {
        const romanNumerals = [
            { value: 1000, numeral: 'M' },
            { value: 900, numeral: 'CM' },
            { value: 500, numeral: 'D' },
            { value: 400, numeral: 'CD' },
            { value: 100, numeral: 'C' },
            { value: 90, numeral: 'XC' },
            { value: 50, numeral: 'L' },
            { value: 40, numeral: 'XL' },
            { value: 10, numeral: 'X' },
            { value: 9, numeral: 'IX' },
            { value: 5, numeral: 'V' },
            { value: 4, numeral: 'IV' },
            { value: 1, numeral: 'I' },
        ]

        let result = ''

        romanNumerals.forEach(item => {
            while (num >= item.value) {
                result += item.numeral
                num -= item.value
            }
        })

        return result
    },
    getTemplateContentStyle(field) {
        let style = ''
        let fontSize = parseInt(field.fontSize, 10)
        if (fontSize >= 12) {
            style += `font-size: ${fontSize}px;`
        } else {
            style += `
                font-size: 12px;
                zoom: ${fontSize / 12};
            `
        }

        if (field.fontWeight) {
            style += `font-weight: ${field.fontWeight};`
        }

        if (field.textAlign) {
            style += `text-align: ${field.textAlign};`
        }

        if (field.fontFamliy) {
            style += `font-family: ${field.fontFamliy}, Arial, "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", 'MicrosoftYaHei', sans-serif;`
        }

        return style
    },
    async canAgencyCreateTransport(vm) {
        let res = await api.get_transport_info()
        if (!res.data.canCreateOrder) {
            vm.$confirm(`
                <div class="text-black fs-16">
                    ${vm.$t('you_have_not_activated_this_service_yet_please_contact_the_system_administrator')}
                    <div class="mt-24">Whats App：9375 3269</div>
                </div>
            `, '', {
                confirmButtonText: vm.$t('ok'),
                dangerouslyUseHTMLString: true,
                showCancelButton: false,
            })
        }
        return res.data.canCreateOrder
    },

    dealCustomPdfTemplateData(vm, data, isSign = false) { // 为自定义模板预览和签字时赋值
        const currDate = new Date()
        const monthList: string[] = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        const allFieldList: any[] = util.cloneDeep([
            ...generalFieldList,
            ...timelineFieldList,
            ...helperFieldList,
            ...employerFieldList,
            ...jobOfferFieldList,
            ...feeBreakdownFieldList,
            ...otherFieldList,
        ])

        const measlesDeclarationMap = vm.$store.state.dataMap.measlesDeclarationMap
        const allHelperTypeMap = vm.$store.state.dataMap.allHelperTypeMap
        const genderMap = vm.$store.state.dataMap.genderMap
        const salaryRangeRangeMap = vm.$store.state.dataMap.salaryRangeRangeMap
        const commonDictionary = vm.$store.state.dataMap.commonDictionary
        const houseTypeAllList: any[] = []
        const hkResidentialTypeMap = vm.$store.state.dataMap.hkResidentialTypeMap
        const hkHelperFacilitiesMap = vm.$store.state.dataMap.hkHelperFacilitiesMap
        const contractTypeMap = commonDictionary.contractType || []

        function getHouseType(value, field) { // 获取house type类型的真实值
            if (houseTypeAllList.length) {
                field.realValue = filter.getValueById(value, houseTypeAllList, 'value', 'pageName')
            } else {
                api.helper_houseType_get().then(res => {
                    res.data.forEach(item => {
                        houseTypeAllList.push(item)
                        item.children.forEach(val => {
                            houseTypeAllList.push(val)
                        })
                    })
                    field.realValue = filter.getValueById(value, houseTypeAllList, 'value', 'pageName')
                })
            }
        }

        function getFirstSignerTimeStamp(file) {
            let sign_proxy_agency = util.getValueByPath(file, 'signatureImgPath.sign_proxy_agency.completeSignTimestamp') || util.getValueByPath(file, 'signatureImgPath.sign_proxy_agency.openPageTimestamp')
            let sign_employer = util.getValueByPath(file, 'signatureImgPath.sign_employer.completeSignTimestamp') || util.getValueByPath(file, 'signatureImgPath.sign_employer.openPageTimestamp')
            let sign_helper = util.getValueByPath(file, 'signatureImgPath.sign_helper.completeSignTimestamp') || util.getValueByPath(file, 'signatureImgPath.sign_helper.openPageTimestamp')
            let sign_agency = util.getValueByPath(file, 'signatureImgPath.sign_agency.completeSignTimestamp') || util.getValueByPath(file, 'signatureImgPath.sign_agency.openPageTimestamp')
            let sign_ipa_agency = util.getValueByPath(file, 'signatureImgPath.sign_ipa_agency.completeSignTimestamp') || util.getValueByPath(file, 'signatureImgPath.sign_ipa_agency.openPageTimestamp')
            let sign_sponsor_1 = util.getValueByPath(file, 'signatureImgPath.sign_sponsor_1.completeSignTimestamp') || util.getValueByPath(file, 'signatureImgPath.sign_sponsor_1.openPageTimestamp')
            let sign_sponsor_2 = util.getValueByPath(file, 'signatureImgPath.sign_sponsor_2.completeSignTimestamp') || util.getValueByPath(file, 'signatureImgPath.sign_sponsor_2.openPageTimestamp')
            let arr = [sign_proxy_agency, sign_employer, sign_helper, sign_agency, sign_ipa_agency, sign_sponsor_1, sign_sponsor_2].filter(item => item).sort((a,b) => a-b)
            return arr[0]
        }

        function setFieldVal(file, field) { // 设置field的真实值
            if (field.fieldType === 'system') {
                let val = util.getValueByPath(file, field.property)
                let idVal = util.getValueByPath(file, field.idProperty)
                let salaryRange = ''
                if (field.renderType === 'table') {
                    let row = (val || [])[field.tableIndex] || {}
                    val = row[field.tableProperty]
                }
                switch (field.key) { // 需要特殊取值的字段
                    case 'general-CaseType':
                        val = filter.getValueById(val, contractTypeMap)
                        break
                    case 'helper-HelperType':
                        val = filter.getValueById(val, allHelperTypeMap)
                        break
                    case 'employer-MonthlyIncomeRange':
                        if (val == null && idVal == null) {
                            salaryRange = ''
                        } else {
                            salaryRange = val + ',' + (idVal == null ? '' : idVal)
                        }
                        val = filter.getValueById(salaryRange, salaryRangeRangeMap)
                        break
                    case 'employer-GenderEmployer':
                    case 'employer-GenderSpouse':
                        val = filter.getValueById(val, genderMap)
                        break
                    case 'jobOffer-HousingType':
                    case 'employer-HousingType':
                        if (idVal !== 15) {
                            getHouseType(idVal, field)
                            return
                        }
                        break
                    case 'jobOffer-NumberAgeOfChildren':
                        val = filter.childInfoFilter(val, idVal)
                        break
                    case 'jobOffer-NumberAndTypeOfPets':
                        val = filter.petFilter(val)
                        break
                    case 'jobOffer-ExpectedDeploymentDate':
                        if (idVal) {
                            val = 'ASAP'
                        } else {
                            val = filter.dateFilter(val)
                        }
                        break
                    case 'jobOffer-MeaslesDeclaration':
                        val = filter.getValueById(val, measlesDeclarationMap)
                        break
                    case 'jobOffer-ResidentialType':
                        val = filter.getValueById(val, hkResidentialTypeMap)
                        break
                    case 'jobOffer-FacilitiesToBeProvidedToHelper':
                        val = filter.multiSelectString(val, hkHelperFacilitiesMap)
                        break
                    case 'employer-ResidentialAddress':
                        {
                            let result = ''
                            result = result + (file.employerInfo.residentialAddress ? file.employerInfo.residentialAddress : '')
                                + (file.employerInfo.residentialLevel ? (', #' + file.employerInfo.residentialLevel + '-' + file.employerInfo.residentialUnit) : '')
                                + (file.employerInfo.existResidentialUnitNo ? ', Unit No. not applicable' : '')
                                + (file.employerInfo.residentialPostalCode ? (', ' + file.employerInfo.residentialPostalCode) : '')
                            if (result.split(',')[0].length === 0) {
                                result = result.split(',')[1]
                            }
                            val = result
                        }
                        break
                    case 'employer-FamilyMemberIDType':
                        {
                            let result = commonDictionary.idType.find(item => item.value === val)
                            val = result ? result.name : ''
                        }
                        break
                    case 'employer-FamlilyMemeberRelationship':
                        {
                            let result = commonDictionary.relationship.find(item => item.value === val)
                            val = result ? result.name : ''
                        }
                        break
                    case 'employer-Sponsor1RelationshipToEmployer':
                    case 'employer-Sponsor2RelationshipToEmployer':
                        {
                            let result = commonDictionary.relationshipWithEmployer.find(item => item.value === val)
                            val = result ? result.name : ''
                        }
                        break
                    default:
                        break
                }
                if (field.valueFormat === 'date') {
                    val = filter.dateFilter(val, ...(field.formatParams || []))
                } else if (field.valueFormat === 'money') {
                    val = filter.thousandBitSeparator(val)
                }
                field.realValue = val
            } else if (field.fieldType === 'currentDate') {
                field.realValue = filter.dateFilter(currDate)
            } else if (field.fieldType === 'currentYear') {
                field.realValue = currDate.getFullYear()
            } else if (field.fieldType === 'currentMonth') {
                field.realValue = String(currDate.getMonth() + 1).padStart(2, '0')
            } else if (field.fieldType === 'currentMonthSpelledOut') {
                field.realValue = monthList[currDate.getMonth()]
            } else if (field.fieldType === 'currentDay') {
                field.realValue = String(currDate.getDate()).padStart(2, '0')
            } else if (field.fieldType === 'SignTimeStamp') {
                if (field.key === 'other-FirstSignerTimeStamp') {
                    field.realValue = getFirstSignerTimeStamp(file)
                } else {
                    field.realValue = util.getValueByPath(file, field.property)
                }

                field.realValue = util.formatGmtTimeStr(field.realValue, field.timeFormat || 1)
            }
        }


        function judgeCondition(file, condition) { // 判断condition组件的条件A和条件B
            let result: any = null
            if (condition.conditionA && condition.conditionB) {
                let conditionAInfo = allFieldList.find(item => item.key === condition.conditionA)
                let conditionBInfo = allFieldList.find(item => item.key === condition.conditionB)
                let conditionAVal = conditionAInfo ? util.getValueByPath(file, conditionAInfo.property) : null
                let conditionBVal = conditionBInfo ? util.getValueByPath(file, conditionBInfo.property) : null
                let conditionAIdVal = util.getValueByPath(file, conditionAInfo.idProperty)
                if (conditionAInfo.conditionType === 'date') {
                    conditionBVal = condition.conditionB
                    if (condition.conditionA === 'other-CurrentDate') {
                        conditionAVal = currDate.getTime()
                    }
                    if (conditionAVal && conditionBVal) {
                        conditionAVal = new Date(conditionAVal).setHours(0, 0, 0, 0)
                        conditionBVal = new Date(conditionBVal).setHours(0, 0, 0, 0)
                        // console.log('date conditionAVal: ', conditionAVal, typeof conditionAVal, new Date(conditionAVal))
                        // console.log('date conditionBVal: ', conditionBVal, typeof conditionBVal, new Date(conditionBVal))
                        switch (condition.operation) {
                            case '>':
                                result = conditionAVal > conditionBVal
                                break
                            case '<':
                                result = conditionAVal < conditionBVal
                                break
                            case '=':
                                result = conditionAVal === conditionBVal
                                break
                            case '≥':
                                result = conditionAVal >= conditionBVal
                                break
                            case '≤':
                                result = conditionAVal <= conditionBVal
                                break
                            default:
                                break
                        }
                    }
                } else if (['char', 'number'].includes(conditionAInfo.conditionType)) {
                    if (condition.conditionBFieldKey) {
                        conditionBInfo = allFieldList.find(item => item.key === condition.conditionBFieldKey)
                        if (conditionBInfo) {
                            conditionBVal = util.getValueByPath(file, conditionBInfo.property)
                        }
                    } else {
                        conditionBVal = condition.conditionB
                    }
                    if (condition.conditionA === 'other-CurrentYear') {
                        conditionAVal = currDate.getFullYear()
                    } else if (condition.conditionA === 'other-CurrentMonth') {
                        conditionAVal = String(currDate.getMonth() + 1).padStart(2, '0')
                    } else if (condition.conditionA === 'other-CurrentMonthSpelledOut') {
                        conditionAVal = monthList[currDate.getMonth()]
                    } else if (condition.conditionA === 'other-CurrentDay') {
                        conditionAVal = String(currDate.getDate()).padStart(2, '0')
                    } else if (conditionAInfo.fieldType === 'SignTimeStamp') {
                        if (conditionAInfo.key === 'other-FirstSignerTimeStamp') {
                            conditionAVal = getFirstSignerTimeStamp(file)
                        } else {
                            conditionAVal = util.getValueByPath(file, conditionAInfo.property)
                        }
                        conditionAVal = util.formatGmtTimeStr(conditionAVal, conditionAInfo.timeFormat || 1)
                    }
                    // console.log('char number conditionAVal: ', conditionAVal, typeof conditionAVal)
                    // console.log('char number conditionBVal: ', conditionBVal, typeof conditionBVal)
                    if (conditionAVal != null && conditionBVal != null) {
                        if (conditionAInfo.conditionType === 'number') {
                            conditionAVal = +conditionAVal
                            conditionBVal = +conditionBVal
                        }
                        switch (condition.operation) {
                            case '>':
                                result = conditionAVal > conditionBVal
                                break
                            case '<':
                                result = conditionAVal < conditionBVal
                                break
                            case '=':
                                result = conditionAVal === conditionBVal
                                break
                            case '≥':
                                result = conditionAVal >= conditionBVal
                                break
                            case '≤':
                                result = conditionAVal <= conditionBVal
                                break
                            default:
                                break
                        }
                    }
                } else if (conditionAInfo.conditionType === 'enum') {
                    if (condition.conditionA === 'employer-MonthlyIncomeRange') {
                        if (conditionAVal == null && conditionAIdVal == null) {
                            conditionAIdVal = null
                        } else {
                            conditionAIdVal = conditionAVal + ',' + (conditionAIdVal == null ? '' : conditionAIdVal)
                        }
                    } else if (condition.conditionA === 'jobOffer-HaveChildren') {
                        if (conditionAIdVal > 0) {
                            conditionAIdVal = 1
                        }
                    } else if (['feeBreakdown-InsurancePlanChosen'].includes(condition.conditionA)) {
                        const companyInfo = allFieldList.find(item => item.key === 'feeBreakdown-InsuranceCompany')
                        const companyId = util.getValueByPath(file, companyInfo.idProperty)
                        conditionAIdVal = companyId + '-' + conditionAIdVal
                    } else if (conditionAInfo.idProperty == null) {
                        conditionAIdVal = conditionAVal
                    }

                    // console.log('enum conditionAIdVal: ', conditionAIdVal, typeof conditionAIdVal)
                    // console.log('enum condition.conditionB: ', condition.conditionB, typeof condition.conditionB)
                    if (conditionAIdVal != null) {
                        result = conditionAIdVal === condition.conditionB
                        switch (condition.operation) {
                            case '=':
                                result = String(conditionAIdVal) === condition.conditionB.join()
                                break
                            case 'beIncluded':
                                result = condition.conditionB.includes(conditionAIdVal)
                                break
                            default:
                                break
                        }
                    }
                } else if (conditionAInfo.conditionType === 'set') {
                    if (['jobOffer-FacilitiesToBeProvidedToHelper'].includes(condition.conditionA)) {
                        conditionAVal = conditionAVal || []
                    } else if (['feeBreakdown-InsuranceAddOns'].includes(condition.conditionA)) {
                        const companyInfo = allFieldList.find(item => item.key === 'feeBreakdown-InsuranceCompany')
                        const companyId = util.getValueByPath(file, companyInfo.idProperty)
                        conditionAVal = (conditionAIdVal || []).map(item => companyId + '-' + item)
                    } else {
                        conditionAVal = util.getValueByPath(file, conditionAInfo.idProperty) || []
                    }
                    // console.log('set conditionAVal: ', conditionAVal, typeof conditionAVal)
                    // console.log('set condition.conditionB: ', condition.conditionB, typeof condition.conditionB)
                    if (condition.conditionB.length && conditionAVal && conditionAVal.length) {
                        switch (condition.operation) {
                            case 'includes':
                                result = condition.conditionB.every(item => conditionAVal.includes(item))
                                break
                            case 'excludes':
                                result = !condition.conditionB.some(item => conditionAVal.includes(item))
                                break
                            case 'equalsTo':
                                result = condition.conditionB.every(item => conditionAVal.includes(item)) && conditionAVal.every(item => condition.conditionB.includes(item))
                                break
                            case 'beIncluded':
                                result = conditionAVal.every(item => condition.conditionB.includes(item))
                                break
                            case 'includesAnyOf':
                                result = conditionAVal.some(item => condition.conditionB.includes(item))
                                break
                            default:
                                break
                        }
                    }
                }
            }
            return result
        }

        const customRequireSignField = {}
        vm.customPdfList.forEach(templateId => { // 遍历所有自定义的pdf
            const file = data[templateId]
            let employerOrder = 1
            let helperOrder = 1
            let agencyOrder = 1
            let ipaAgencyOrder = 1
            let sponsor1Order = 1
            let sponsor2Order = 1
            file.templateInfo.pageList = JSON.parse(file.templateInfo.templateContentText)
            file.templateInfo.pageList.forEach(page => { // 遍历pdf的所有页
                const existTableKey: string[] = [] // 已经加上tableIndex的表格字段key
                const keyRealValue = {}
                page.fieldList.forEach(field => { // 遍历每页的所有字段,加上tableIndex
                    const currConfig = allFieldList.find(item => item.key === field.key)
                    Object.assign(field, currConfig)
                    if (field.fieldType === 'system' && field.renderType === 'table' && !existTableKey.includes(field.key)) { // 给相同key的表格字段加上tableIndex
                        existTableKey.push(field.key)
                        page.fieldList.filter(item => item.key === field.key) // 找出当前页所有相同key的表格字段
                            .sort((a, b) => a.coordinateY - b.coordinateY) // 按y坐标从上到下排列
                            .forEach((item, index) => {
                                item.tableIndex = index
                            })
                    }

                    if (field.fieldType === 'condition') { // if控件需要特殊处理
                        let conditionInfo = field.conditionInfoList.find(item => {
                            if (item.combineMethod === 'and') {
                                return item.conditionList.every(condition => judgeCondition(file, condition))
                            }
                            if (item.combineMethod === 'or') {
                                return item.conditionList.some(condition => judgeCondition(file, condition))
                            }
                        })
                        if (conditionInfo) {
                            if (conditionInfo.outputFieldKey) {
                                let outputInfo = allFieldList.find(item => item.key === conditionInfo.outputFieldKey)
                                if (outputInfo) {
                                    outputInfo = util.cloneDeep(outputInfo)
                                    setFieldVal(file, outputInfo)
                                    field.realValue = outputInfo.realValue
                                }
                            } else {
                                field.realValue = conditionInfo.output
                            }
                        } else if (field.elseOutputFieldKey) {
                            let elseOutputInfo = allFieldList.find(item => item.key === field.elseOutputFieldKey)
                            if (elseOutputInfo) {
                                elseOutputInfo = util.cloneDeep(elseOutputInfo)
                                setFieldVal(file, elseOutputInfo)
                                field.realValue = elseOutputInfo.realValue
                            }
                        } else {
                            field.realValue = field.elseOutput
                        }
                    } else if (field.fieldType === 'householdMemberCountByAgeRange') {
                        if (!validate.isEmpty(field.min) && !validate.isEmpty(field.max)) {
                            let count = 0;
                            [
                                file.employerInfo.employerAge,
                                file.employerInfo.spouseAge,
                                ...file.employerInfo.familyMemberList.map(item => item.age)
                            ].forEach(item => {
                                if (!validate.isEmpty(item) && item >= +field.min && item < +field.max) {
                                    count++
                                }
                            })
                            field.realValue = count
                        }
                    } else if (field.fieldType !== 'formula') { // 设置字段真实值
                        setFieldVal(file, field)
                        keyRealValue[field.key] = field.realValue
                    }
                })
                page.fieldList.forEach(field => { // 给formula字段赋值
                    if (field.fieldType === 'formula') {
                        let expression = ''
                        field.expressionList.forEach(e => {
                            if (e.key) {
                                if (!keyRealValue.hasOwnProperty(e.key)) {
                                    setFieldVal(file, e)
                                    keyRealValue[e.key] = e.realValue
                                }
                                e.realValue = (keyRealValue[e.key] == null || keyRealValue[e.key] === '') ? 0 : keyRealValue[e.key]
                            }
                            expression += e.realValue
                        })
                        try {
                            let val = eval((expression + '').replace(',', ''))
                            if (!Number.isNaN(val) && Number.isFinite(val)) {
                                field.realValue = NP.strip(val).toFixed(2)
                            }
                        } catch (e) {
                            console.log('formula error:', expression, e)
                        }
                    }
                })

                const signatureList = page.fieldList.filter(item => item.fieldType === 'signature')
                signatureList.sort((a, b) => a.coordinateY - b.coordinateY)
                signatureList.forEach(item => { // 处理签字控件
                    let signType = ''
                    let signKey = ''
                    switch (item.subType) {
                        case 'sign_employer':
                            signType = 'sign_employer'
                            signKey = 'employer' + employerOrder++
                            break
                        case 'sign_helper':
                            signType = 'sign_helper'
                            signKey = 'helper' + helperOrder++
                            break
                        case 'sign_agency':
                            signType = 'sign_agency'
                            signKey = 'agency' + agencyOrder++
                            break
                        case 'sign_ipa_agency':
                            signType = 'sign_ipa_agency'
                            signKey = 'ipaAgency' + ipaAgencyOrder++
                            break
                        case 'sign_sponsor_1':
                            signType = 'sign_sponsor_1'
                            signKey = 'sponsor1_' + sponsor1Order++
                            break
                        case 'sign_sponsor_2':
                            signType = 'sign_sponsor_2'
                            signKey = 'sponsor2_' + sponsor2Order++
                            break
                        case 'sign_proxy_agency':
                            signType = 'sign_proxy_agency'
                            signKey = 'proxy_agency_' + sponsor2Order++
                            break
                        default:
                            break
                    }
                    item.id = 'file' + templateId + signKey
                    item.signType = signType
                    item.signKey = signKey
                    if (!file.signatureImgPath) {
                        file.signatureImgPath = {}
                    }
                    if (!file.signatureImgPath[signType]) {
                        file.signatureImgPath[signType] = {}
                    }
                    if (!file.signatureImgPath[signType][signKey]) {
                        file.signatureImgPath[signType][signKey] = ''
                    }

                    if (isSign && (data.signType === signType)) {
                        if (!customRequireSignField[templateId]) {
                            customRequireSignField[templateId] = {}
                        }
                        if (!customRequireSignField[templateId][signType]) {
                            customRequireSignField[templateId][signType] = [signKey]
                        } else {
                            customRequireSignField[templateId][signType].push(signKey)
                        }
                    }
                })
            })
            file.signField = isSign ? Object.keys(file.signatureImgPath[data.signType]) : []
        })
        if (isSign) {
            vm.customRequireSignField = customRequireSignField
        }
        return currDate.getTime()
    },

    downloadContractFile(vm, list, refNo, name, isLastest?: any, needContractFilePath?: any, showAll?: any, companyId?, pdfSizeList?, loginUserType?) {
        api.contract_pdf_download({
            pdfList: list,
            pdfSizeList,
            code: refNo,
            timeStamp: formatDate(new Date(), 'yyyyMMddhhmmss'),
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            isLastest,
            needContractFilePath,
            showAll,
            companyId: companyId || vm.userCompanyInfo.id,
            loginUserType,
        }).then(res => {
            let ab = Buffer.from(res.data.pdf, 'binary')
            const blob = new Blob([ab], {
                type: 'pdf',
            })
            let url = window.URL.createObjectURL(blob)
            let fileName = ''
            if (name && name.length > 0) {
                fileName = name + '.pdf'
            } else {
                fileName = res.data.fileName
            }
            util.downloadFile(url, fileName)
        }).finally(() => {
            vm.$emit('handleComplete', true)
        })
    },

    jumpDashboard(vm) {
        let userCompanyInfo = JSON.parse((window.localStorage.getItem('userCompanyInfo')) as any) || {}
        let name: string
        if (userCompanyInfo.type === 'adm') {
            name = 'AgencyList'
        } else if (userCompanyInfo.supplierId) {
            name = 'HelperList'
        } else if (userCompanyInfo.type === 'supplier') {
            name = 'DashboardForSupplier'
        } else if (userCompanyInfo.type === 'transport') {
            name = 'pjOrderList'
        } else if (userCompanyInfo.type === 'insurance') {
            name = 'DashboardForInsurance'
        } else if (userCompanyInfo.type === 'lending') {
            name = 'DashboardForLending'
        } else if (userCompanyInfo.type === 'training') {
            name = 'DashboardForTraining'
        } else if (userCompanyInfo.roleType === 'DRIVER') {
            name = 'DriverScheduleList'
        } else if (userCompanyInfo.roleNames === 'External Recruiter') {
            name = 'HelperList'
        } else {
            let userInfo = JSON.parse((window.localStorage.getItem('userInfo')) as any) || {}
            if (userInfo.userId === 248) { // isGoogleVerifyAccount
                name = 'EmployerList'
            } else {
                name = 'Dashboard'
            }
        }

        if (vm.$route.name === name) {
            window.location.reload()
        } else {
            window.location.href = vm.$router.resolve(<any>{
                name,
            }).href
        }
    },

    // 滑动切换
    suportTouchCarousel(box, carousel) {
        // 选中的轮播图
        // console.log('touchCarousel box: ', box)
        let startPointX = 0
        let stopPointX = 0
        // 重置坐标
        function resetPoint() {
            startPointX = 0
            stopPointX = 0
        }
        // 手指按下
        box.addEventListener('touchstart', e => {
            // 手指点击位置的X坐标
            startPointX = e.changedTouches[0].pageX
        })
        // 手指滑动
        box.addEventListener('touchmove', e => {
            // 手指滑动后终点位置X的坐标
            stopPointX = e.changedTouches[0].pageX
        })
        // 当手指抬起的时候，判断图片滚动离左右的距离
        box.addEventListener('touchend', e => {
            if (stopPointX === 0 || startPointX - stopPointX === 0) {
                resetPoint()
                return
            }
            if (startPointX - stopPointX > 0) {
                resetPoint()
                carousel.next()
                return
            }
            if (startPointX - stopPointX < 0) {
                resetPoint()
                carousel.prev()
            }
        })
    },

    renderAIInsightRequestExtract(vm, requestCategory, data) {
        if (!requestCategory) {
            return '[ <span class="text-red">Not Real Employer</span>]'
        }

        let extendInfo = data.extendInfo || {}
        extendInfo.helperType = Object.assign(extendInfo.helperType || {}, { value: filter.multiSelectString(data.helperType, vm.allHelperTypeMap) })
        extendInfo.nationality = Object.assign(extendInfo.nationality || {}, { value: filter.multiSelectString(data.nationality, vm.dictionary.helperNationality) })
        extendInfo.religion = Object.assign(extendInfo.religion || {}, { value: filter.multiSelectString(data.religion, vm.dictionary.religion) })
        if (data.ageMin || data.ageMax) {
            extendInfo.ageMin = Object.assign(extendInfo.ageMin || {}, { value: 'Age ' + data.ageMin + '-' + data.ageMax })
        }
        extendInfo.educationLevel = Object.assign(extendInfo.educationLevel || {}, { value: filter.multiSelectString(data.educationLevel, vm.dictionary.educationLevel) })
        extendInfo.maritalStatus = Object.assign(extendInfo.maritalStatus || {}, { value: filter.multiSelectString(data.maritalStatus, vm.dictionary.maritalStatus) })
        if (data.haveChild != null) {
            extendInfo.haveChild = Object.assign(extendInfo.haveChild || {}, { value: 'Have Child? ' + (data.haveChild ? vm.$t('yes') : vm.$t('no')) })
        }
        extendInfo.languageSkills = Object.assign(extendInfo.languageSkills || {}, { value: filter.multiSelectString(data.languageSkills, vm.dictionary.languageSkills) })
        extendInfo.cookingSkills = Object.assign(extendInfo.cookingSkills || {}, { value: filter.multiSelectString(data.cookingSkills, vm.dictionary.cookingSkills) })
        if (data.workNationalityId && data.workNationalityId.length) {
            extendInfo.workNationalityId = Object.assign(extendInfo.workNationalityId || {}, { value: 'Working Experience in: ' + filter.multiSelectString(data.workNationalityId, vm.dictionary.workingExperienceIn) })
        }
        if (data.completionOfContract) {
            extendInfo.completionOfContract = Object.assign(extendInfo.completionOfContract || {}, { value: 'No. of Completed Contract: ' + data.completionOfContract })
        }
        if (data.caringSkills && data.caringSkills.length) {
            extendInfo.caringSkills = Object.assign(extendInfo.caringSkills || {}, { value: 'Caregiving Experience: ' + filter.multiSelectString(data.caringSkills, vm.dictionary.caringSkills) })
        }
        if (data.workSkills && data.workSkills.length) {
            extendInfo.workSkills = Object.assign(extendInfo.workSkills || {}, { value: 'Special Work Experience: ' + filter.multiSelectString(data.workSkills, vm.dictionary.workSkills) })
        }
        if (data.otherSkills && data.otherSkills.length) {
            extendInfo.otherSkills = Object.assign(extendInfo.otherSkills || {}, { value: 'Other Skills Experience: ' + filter.multiSelectString(data.otherSkills, vm.dictionary.otherSkills) })
        }
        if (data.salaryMin || data.salaryMax) {
            extendInfo.salaryMin = Object.assign(extendInfo.salaryMin || {}, { value: 'Salary ' + data.salaryMin + '-' + data.salaryMax })
        }
        if (data.heightMin || data.heightMax) {
            extendInfo.heightMin = Object.assign(extendInfo.heightMin || {}, { value: filter.getValueById(data.heightMin, vm.heightMap) + '-' + filter.getValueById(data.heightMax, vm.heightMap) })
        }
        if (data.weightMin || data.weightMax) {
            extendInfo.weightMin = Object.assign(extendInfo.weightMin || {}, { value: filter.getValueById(data.weightMin, vm.weightMap) + '-' + filter.getValueById(data.weightMax, vm.weightMap) })
        }
        if (data.workDuty && data.workDuty.length) {
            extendInfo.workDuty = Object.assign(extendInfo.workDuty || {}, { value: 'Work Duties: ' + filter.multiSelectString(data.workDuty, vm.dictionary.workDuty) })
        }
        let list: string[] = []
        // console.log(JSON.stringify(Object.entries(extendInfo).filter(item => item[1]).sort((a: any, b: any) => (b[1].priority || 0 - a[1].priority || 0)), null, 4))
        Object.entries(extendInfo).filter(item => item[1]).sort((a: any, b: any) => ((b[1].priority || 0) - (a[1].priority || 0))).forEach((arr)  => {
            const item: any = arr[1]
            if (item.value) {
                list.push((item.priority ? '<span class="text-red">' + item.priority + '.</span>' : '') + '[' + item.value + ']')
            }
        })
        const result = list.length ? list.join(' | ') : ''
        // console.log('renderAIInsightRequestExtract: ', JSON.stringify(extendInfo, null, 4), result)
        return result
    },
}
